import { LanguageCode } from "@timeedit/registration-schemas";
import { Locale } from "@timeedit/ui-components/antd/locale/index";
import enGB from "@timeedit/ui-components/antd/locale/en_GB";
import svSE from "@timeedit/ui-components/antd/locale/sv_SE";

export const locales: Record<LanguageCode, Locale> = {
  en: enGB,
  sv: svSE,
};
